module.exports = __webpack_public_path__ + "img/ic_twotone_location.e78cc7a7.png";